import { BadgeCheck, ChartNoAxesCombined, TrendingUp, type LucideIcon } from "lucide-react";

import type { AppraisalLetterType } from "./types.ts";

export type LetterTypeOption = {
  value: AppraisalLetterType;
  title: string;
  description: string;
  icon: LucideIcon;
  tone: "blue" | "green" | "purple";
  fields: {
    compensation: boolean;
    designation: boolean;
  };
};

export const LETTER_TYPE_OPTIONS: readonly LetterTypeOption[] = [
  {
    value: "APPRAISAL",
    title: "Appraisal Letter",
    description: "Generate an appraisal letter based on performance and compensation.",
    icon: TrendingUp,
    tone: "blue",
    fields: { compensation: true, designation: false },
  },
  {
    value: "PROMOTION",
    title: "Promotion Letter",
    description: "Generate a promotion letter with designation details.",
    icon: BadgeCheck,
    tone: "green",
    fields: { compensation: false, designation: true },
  },
  {
    value: "APPRAISAL_WITH_PROMOTION",
    title: "Appraisal with Promotion Letter",
    description: "Generate a combined letter with appraisal and promotion details.",
    icon: ChartNoAxesCombined,
    tone: "purple",
    fields: { compensation: true, designation: true },
  },
] as const;
